import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
// import tm_MenuPage from '@/components/pages/tm-menu-page.vue';
// import tm_OrderPage from '@/components/pages/tm-order-page.vue';
// import tm_MessagesPage from '@/components/pages/tm-messages-page.vue';
// import tm_PayPage from '@/components/pages/tm-pay-page.vue';
// import tm_GetAppPage from '@/components/pages/tm-get-app-page.vue';
// import tm_InfoPage from '@/components/pages/tm-info-page.vue';
// import tm_SettingsPage from '@/components/pages/tm-settings-page.vue';
// import tm_PastOrders from '@/components/pages/tm-past-orders.vue';
// import tm_LocationSelection from '@/components/pages/tm-location-selection.vue';
// import tm_MenuSelection from '@/components/pages/tm-menu-selection.vue';
import { store } from '@/store.ts';
import * as Util from '@/util.ts';
import * as Constants from '@/constants.ts';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to: any, from: any, savedPosition: any) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  // Don't forget to update the list all routes in index.html as well.
  routes: [
    {
      path: '/',
      alias: [`/:permalinkId${Constants.allRoutes.menu}`, `${Constants.allRoutes.menu}`],
      name: 'Menu',
      // component: tm_MenuPage,
      component: () => import(/* webpackChunkName: "menuAndOrder" */ '@/components/pages/tm-menu-page.vue'),
    },
    {
      path: Constants.allRoutes.order,
      alias: [`/:permalinkId${Constants.allRoutes.order}`],
      name: 'Order',
      // component: tm_OrderPage,
      component: () => import(/* webpackChunkName: "menuAndOrder" */ '@/components/pages/tm-order-page.vue'),
    },
    {
      path: Constants.allRoutes.messages,
      alias: [`/:permalinkId${Constants.allRoutes.messages}`],
      name: 'Messages',
      // component: tm_MessagesPage,
      component: () => import(/* webpackChunkName: "messages" */ '@/components/pages/tm-messages-page.vue'),
    },
    {
      path: Constants.allRoutes.pay,
      alias: [`/:permalinkId${Constants.allRoutes.pay}`],
      name: 'Pay',
      // component: tm_PayPage,
      component: () => import(/* webpackChunkName: "pay" */ '@/components/pages/tm-pay-page.vue'),
    },
    {
      path: Constants.allRoutes.getApp,
      alias: [`/:permalinkId${Constants.allRoutes.getApp}`],
      name: 'Get App',
      // component: tm_GetAppPage,
      component: () => import(/* webpackChunkName: "getApp" */ '@/components/pages/tm-get-app-page.vue'),
    },
    {
      path: Constants.allRoutes.info,
      alias: [`/:permalinkId${Constants.allRoutes.info}`],
      name: 'Info',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.settings,
      alias: [`/:permalinkId${Constants.allRoutes.settings}`],
      name: 'Settings',
      // component: tm_SettingsPage,
      component: () => import(/* webpackChunkName: "settings" */ '@/components/pages/tm-settings-page.vue'),
    },
    {
      path: Constants.allRoutes.locationSelection,
      alias: [`/:permalinkId${Constants.allRoutes.locationSelection}`],
      name: 'Location Selection',
      // component: tm_LocationSelection,
      component: () => import(/* webpackChunkName: "locationSelection" */ '@/components/pages/tm-location-selection.vue'),
    },
    {
      path: Constants.allRoutes.menuSelection,
      alias: [`/:permalinkId${Constants.allRoutes.menuSelection}`],
      name: 'Menu Selection',
      // component: tm_MenuSelection,
      component: () => import(/* webpackChunkName: "menuSelection" */ '@/components/pages/tm-menu-selection.vue'),
    },

    // URL Route Modals.
    {
      path: Constants.allRoutes.demoMenuModal,
      alias: [`/:permalinkId${Constants.allRoutes.demoMenuModal}`],
      name: 'Demo Menu',
      // component: tm_MenuPage,
      component: () => import(/* webpackChunkName: "menuAndOrder" */ '@/components/pages/tm-menu-page.vue'),
    },
    {
      path: Constants.allRoutes.menuItemModal,
      alias: [`/:permalinkId${Constants.allRoutes.menuItemModal}`],
      name: 'Menu Item',
      // component: tm_MenuPage,
      component: () => import(/* webpackChunkName: "menuAndOrder" */ '@/components/pages/tm-menu-page.vue'),
    },
    {
      path: Constants.allRoutes.filtersModal,
      alias: [`/:permalinkId${Constants.allRoutes.filtersModal}`],
      name: 'Filters',
      // component: tm_MenuPage,
      component: () => import(/* webpackChunkName: "menuAndOrder" */ '@/components/pages/tm-menu-page.vue'),
    },
    {
      path: Constants.allRoutes.messageOptionsModal,
      alias: [`/:permalinkId${Constants.allRoutes.messageOptionsModal}`],
      name: 'Messages Options',
      // component: tm_MessagesPage,
      component: () => import(/* webpackChunkName: "messages" */ '@/components/pages/tm-messages-page.vue'),
    },
    {
      path: Constants.allRoutes.termsOfServiceModal,
      alias: [`/:permalinkId${Constants.allRoutes.termsOfServiceModal}`],
      name: 'Terms of Service',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.privacyPolicyModal,
      alias: [`/:permalinkId${Constants.allRoutes.privacyPolicyModal}`],
      name: 'Privacy Policy',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.cookiePolicyModal,
      alias: [`/:permalinkId${Constants.allRoutes.cookiePolicyModal}`],
      name: 'Cookie Policy',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.aboutUsModal,
      alias: [`/:permalinkId${Constants.allRoutes.aboutUsModal}`],
      name: 'About Us',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.howItWorksModal,
      alias: [`/:permalinkId${Constants.allRoutes.howItWorksModal}`],
      name: 'How it Works',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.whatIsNfc,
      alias: [`/:permalinkId${Constants.allRoutes.whatIsNfc}`],
      name: 'What is NFC',
      // component: tm_InfoPage,
      component: () => import(/* webpackChunkName: "info" */ '@/components/pages/tm-info-page.vue'),
    },
    {
      path: Constants.allRoutes.billDetailsModal,
      alias: [`/:permalinkId${Constants.allRoutes.billDetailsModal}`],
      name: 'Bill Defails',
      // component: tm_PayPage,
      component: () => import(/* webpackChunkName: "pay" */ '@/components/pages/tm-pay-page.vue'),
    },
    {
      path: Constants.allRoutes.billModal,
      alias: [`/:permalinkId${Constants.allRoutes.billModal}`],
      name: 'Bill',
      // component: tm_PayPage,
      component: () => import(/* webpackChunkName: "pay" */ '@/components/pages/tm-pay-page.vue'),
    },
    {
      path: Constants.allRoutes.pastOrders,
      alias: [`/:permalinkId${Constants.allRoutes.pastOrders}`],
      name: 'Past Orders',
      // component: tm_PastOrders,
      component: () => import(/* webpackChunkName: "pastOrders" */ '@/components/pages/tm-past-orders.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (store.state.isKioskMode && [
    'Pay',
    'Get App',
    'Info',
    'Settings'].includes(to.name as string)) {
    next('/menu');
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  switch (to.path) {
    case '/get-app':
      Util.onShowPWAPrompt();
      break;
  }
});

export default router;
